<template>
    <div class="index-page">
        <img src="../assets/images/1.png" alt="" style="display: none;">
      <div class="page-info">
        <!-- <van-notice-bar
          left-icon="volume-o"
          color="#ed6a0c"
          text="温馨提示：本公司不刷单、不返佣，请勿轻信他人，谨防上当受骗!!!!"
        /> -->
        <div class="title-row">
          <div class="img-logo">
            <img src="../assets/images/ks_icon.png" alt="" />
            <span>快币充值</span>
          </div>
          
          <div class="right-icon">
            <span style="font-size: 12px;display: flex;align-items: center;color: #000" @click="chat">
                <van-icon name="phone-o" size="16"/> 拨打客服电话
            </span>
            </div>

        </div>
      </div>
      <div class="page-main">
        <div class="header">
          <div class="logined" v-if="isLogin">
            <div class="userImg" v-if="needKsDiscern">
              <img :src="userInfo.headImg" alt="" />
            </div>
            <div class="userInfo">
              <p v-if="needKsDiscern" style="margin-bottom: 5px; font-weight: 600">{{userInfo.nickName}}</p>
              <p style="color: #777">ID:{{userInfo.userId}}</p>
            </div>
            <div class="header-bar">
              <van-button color="#fe2c55" size="normal" @click="loginCheckOut">切换账号</van-button>
            </div>
          </div>
  
          <div class="unlogin" v-else>
            <div class="input-group">
              <div class="input-div">
                <input
                  type="text"
                  maxlength="20"
                  :value="accountNumber"
                  @input="onAccountInput"
                  @blur="onBlur"
                  @focus="onfocus"
                  placeholder="请输入快手号"
                />
              </div>
              <div class="header-bar">
                <van-button color="#fe2c55" type="primary" 
                  :disabled="!isAccountValid" 
                  @click="affirmAcNumber"
                  :loading="isLoading" 
                  loading-text="加载中"
                >
                  确认账号
                </van-button>
              </div>
            </div>
            <div></div>
            <div class="account-help">
              <span @click="show = true">如何查看快手号？</span>
            </div>
          </div>
  
  
        </div>
        <div class="content">
          <ul class="item-list" v-if="list[currIdx]">
            <li v-for="(item, index) in list" :key="item.money">
              <div
                class="item"
                :class="{ 'item-active': currIdx === index }"
                @click="handerList(item, index)"
              >
                <span class="hot" v-if="item.type">
                  <em v-if="item.type === 1">{{item.tips}}</em>
                  <em class="through" v-else-if="item.type === 2">￥{{item.tips}}</em>
                  <van-icon name="fire" color="#ffca00"/>
                </span>
                <p class="doubi">
                  <img src="../assets/images/ks_icon.png" alt="" />{{
                    item.doubi
                  }}快币
                </p>
                <p class="rmb">￥{{ item.money }}</p>
              </div>
            </li>
          </ul>
          <div class="complaint" @click="handleComplaint">
            <img src="../assets/images/tusu.png" alt="" width="20">
            投诉入口
        </div>
          <div class="btn-group"></div>
        </div>
        <div class="agreement-row">
          <van-tag type="danger" size="large" @click="show2 = true"><van-icon name="description" />充值协议</van-tag>
          <van-tag type="danger" size="large" @click="handleDialog2"><van-icon name="service-o" />在线客服</van-tag>
        </div>
        <div class="bottom-tips">亲爱的用户，近期平台发现有填写他人账号充值及主播诱导充值的骗局，已有用户被骗。请您提高警惕，切勿轻信此类诱惑，以免遭受财产损失。</div>
      </div>
      <!-- <div class="add-wechat"> 加微低至95折<van-icon name="arrow" /></div> -->
      <div class="page-footer" v-if="list[currIdx]">
        <van-button
          type="danger"
          style="font-weight: 700"
          color="#fe2c55"
          block
          v-show="btnShow"
          :disabled="btnDisabled"
          @click="weChatPay"
          >立即支付 <span>￥{{ list[currIdx].money }}.00</span></van-button
        >
      </div>
      
      <van-dialog class="van-dialog-paytype" v-model="payTypeDialog" :showConfirmButton="false" width="70%" >
        <div class="paytype-wrap">
            <div class="pay-header">
                <van-icon name="close"  size="20" @click="payTypeDialog = false"/>
            </div>
            <div style="padding: 12px 0 0;" v-if="list[currIdx]">
                <div class="row row-img" v-if="needKsDiscern"><img :src="userInfo.headImg" alt=""></div>
                <div class="row" v-if="needKsDiscern"><b>{{userInfo.nickName}}</b></div>
                <div class="row" v-else><b>ID:{{userInfo.userId}}</b></div>
                <div class="row" style="margin-bottom: 30px;">即将给以上账号充值 <em style="color: red">{{list[currIdx].doubi}}</em> 快币</div>

                <div class="pay-footer">
                  <van-button 
                    type="primary" 
                    style="margin-bottom: 15px;" block 
                    color="#00c250" size="larger" icon="wechat-pay"
                    @click="dialogPay('wx')">微信支付</van-button>

                    <van-button  
                      v-if="isApPayAuth"
                      type="primary" 
                      block color="#03A9F4" 
                      size="larger" 
                      icon="alipay"
                      @click="dialogPay('ap')"
                    >
                      支付宝支付
                    </van-button>
                </div>
                
            </div>
        </div>
      </van-dialog>

      <van-dialog class="van-dialog-paytype" v-model="payTypeDialog2" closeOnClickOverlay :showConfirmButton="false" width="90%" >
        
        <div class="paytype-wrap dialog-tips">
          <div class="risk-header">温馨提示</div>
          <div class="risk-body" v-if="list[currIdx] && isSelfCharger">
              <div class="row row-img" v-if="needKsDiscern" style="gap: 10px">
                <img :src="userInfo.headImg" alt="">
                <b>{{userInfo.nickName}}</b>
              </div>
              <div class="row">充值账号：<b style="position: relative;top: 2px">{{userInfo.userId}}</b></div>
              <div class="row" style="margin-bottom: 20px;"> 请确认此为您本人账号！请不要相信陌生人诱导支付，请勿填写他人账号，谨防受骗导致财产损失！ </div>

              <div class="pay-footer">
                  <van-button  style="margin-bottom: 15px;" block 
                  :disabled="!riskChecked || timerCount >0"
                  :color="(riskChecked&&!timerCount)?'#2878ff':''" size="larger"  round
                  @click="payTypeDialog = true; payTypeDialog2 = false">为本人账号充值</van-button>
                  <van-button  block 
                  :disabled="!riskChecked || timerCount >0"
                  :color="(riskChecked&&!timerCount)?'#ff2e39':''" size="larger"  round
                  @click="isSelfCharger = false">他人诱导付款充值</van-button>
                  <p>请认真阅读后确认 <span v-if="timerCount">{{timerCount}}s</span></p>
                  <div class="risk-row">
                    <van-checkbox v-model="riskChecked"  icon-size="16px">继续则视为了解本平台为优惠充值平台，该商品是虚拟产品，因虚拟产品的特殊性，<span>充值成功无法退款，请悉知！</span></van-checkbox>
                  </div>
              </div>
          </div>
          <div class="risk-error" v-else>
            <div class="title"> 他人诱导付款充值一律为诈骗！！！ </div>
            <div class="error-list">
              <p>诈骗案例：</p>
              <p> 1、网络课程-冒充导师-共享屏幕-养号涨粉 </p>
              <p> 2、兼职返利-虚假任务-提现 </p>
              <p> 3、低额充值-高额回报 </p>
              <p> 4、主播送礼-游戏点券道具-充值即赠 </p>
              <p> 5、平台私信-冒充好友 </p>
              <van-button   block 
                  color="#2878ff" size="larger"  round
                  @click="getOut">退出</van-button>
            </div>
            
          </div>
        </div>
      </van-dialog>




      <!-- 支付协议 -->
      <van-popup
        v-model="show2"
        round
        position="bottom"
        :style="{ height: '50%' }"
      >
        <div class="agreement-floor">
          <div id="Agreement">
            <!---->
            <div class="floor">
              <p class="text">
                1、付款后实时到账，充值成功后无法进行退款操作。<br><br>
                2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。<br><br>
                3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。<br><br>
                4、本平台为第三方优惠渠道，非官方。
              </p>
            </div>
          </div>
        </div>
      </van-popup>
      <!-- 查看快手号图 -->
      <van-overlay :show="show"  @click="show = false">
        <div class="wrapper" >
          <img
            src="../assets/images/kuaishou.jpg"
            @click="show = false"
            alt=""
            style="height: 80%;"
          />
        </div>
      </van-overlay>
      <!-- 支付选择弹窗 -->
      <!-- <van-dialog v-model="dialog" :show-confirm-button="false">
        <div class="pay-box">
          <van-icon
            name="cross"
            class="close"
            @click="dialog = false"
            color="#999"
            size="18"
          />
          <div class="img-header">
            <img src="../assets/images/user.jpg" alt="" />
          </div>
          <p><b>小王</b></p>
          <div class="pay-group">
            <div style="margin: 30px 0 10px 0; text-align: center">
              即将给以上账户充值 <span style="color: red">60</span> 抖币
            </div>
            <ul class="pay-list">
              <li>
                <van-button
                  type="danger"
                  color="#0dc766"
                  block
                  @click="weChatPay()"
                >
                  <van-icon name="wechat-pay" size="20" />
                  支付测试
                </van-button>
              </li>
              <li>
                <van-button type="danger" color="#2e8ceb" block @click="weChatPay()">
                  <van-icon name="alipay" size="20" />
                  支付宝支付
                </van-button>
              </li>
            </ul>
          </div>
        </div>
      </van-dialog> -->
      <!-- 在线客服弹窗 -->
      <van-overlay :show="dialog2">
        <div class="wrapper">
          <div class="customer-dialog">
            <div class="customer-header">
              <label>联系客服</label>
              <van-icon size="20" name="cross" @click="dialog2 = false"/>
            </div>
            <div class="customer-body">
              <div class="flex-row">
                <van-icon color="#ff9800" size="28px" name="question-o" />
                <span>请选择联系客服的方式</span>
              </div>
            </div>
            <div class="footer-btn">
              <van-tag type="primary" size="large" @click="callUs('phone')">电话客服</van-tag>
              <van-tag plain type="primary" size="large" @click="callMe('online')">在线客服</van-tag>
            </div>
          </div>
          
        </div>
      </van-overlay>

       
    </div>
  </template>
  
  <script>
  import { duration } from "moment";
import { getAvatarInfoKs, reqPayParams,getKsAccoutInfo,skuList, apPayAuto } from "../api/api";
import router from "../router";
  import { getUrlCode } from "../utils/wxConfig";
  import qs from  'qs' 
  export default {
    components: {},
    data() {
      return {
      isLoading: false,
        isLogin: false, // 是否获取到快手号
        dialog: false,
        dialog2: false,
        currIdx: 2,
        currItem: {},
        show: false,
        show2: false,
        btnDisabled: true,
        
        btnShow: true,
        accountNumber: "",
        list: [],
        userInfo: {}, // 用户信息
        payTypeDialog: false,
        needUserCode: true,
        toastLoading: null,
        isApPayAuth: false,
        riskChecked: true,
        timerCount: 3,
        timer: null,
        isSelfCharger: true, // 是否自己充值
        payTypeDialog2: false,
        // 账号识别开关：true 走识别接口（识别成功或超3秒无响应则成功，接口报错不成功）；false 无须识别，确认后直接成功
        needKsDiscern: false,
      };
    },
    computed: {
        blackList() {
            return this.$store.state.BLACKLIST;
        },
        // 域名下参数
        webInfoObj() {
            const _webInfo = this.$store.state.websiteInfo;
            return _webInfo[location.host] || _webInfo.defaultData;
        },
        isAccountValid() {
          return /^[a-zA-Z0-9_-]{2,20}$/.test(this.accountNumber);
        }
    },
    created() {
        this.toastLoading && this.toastLoading.clear()
        // 企业微信环境（发送网页用标题）
        if(this.is_weixn() && this.isWorkWechat()) {
            document.title = '快币充值入口，点击进入！';
        }
  
    //   this.list = this.webInfoObj.skuDb;  // 获取快手商品数据
    //   console.log(this.list);
        this.getSkuList()
      const ksData = (localStorage.getItem('ksData')) || '';
      if(ksData) {
        this.userInfo = JSON.parse(ksData);
        this.isLogin = true;
        this.btnDisabled = false;
        this.accountNumber = this.userInfo.userId;
      }
  
    },
    methods: {
        getSkuList() {
            const {orderType} = this.webInfoObj;
            skuList(orderType).then(res => {
                if(Array.isArray(res)) {
                    this.list = res.map(item => {
                        const {amount, productNo, sku} = item
                        return {
                            doubi: sku,
                            id: productNo,
                            money: amount
                        }
                    })
                }
            })
        },
        // handleComplaint() {
        //     const {orderType} = this.webInfoObj;
        //     this.$router.push({
        //         path: '/orderList',
        //         query: {
        //             orderType,
        //             type: 'dy',
        //             extParam: getUrlCode('extParam')
        //         }
        //     });
        // },
        handleComplaint() {
            const {orderType} = this.webInfoObj;
            /*
            this.$router.push({
                path: '/orderList',
                query: {
                    orderType,
                    type: 'dy',
                    extParam: getUrlCode('extParam')
                }
            });
            */
            window.location.href = `https://mvp.bxsvip.com/#/orderList?orderType=${orderType}&c&account=${this.accountNumber}`;
        },
        // 是否微信
        is_weixn(){  
            var ua = navigator.userAgent.toLowerCase();  
            if(ua.match(/MicroMessenger/i)=="micromessenger") {  
                return true;  
            } else {  
                return false;  
            }  
        },  
        // 是否企业微信
        isWorkWechat() {
        //获取user-agaent标识头
            var ua = window.navigator.userAgent.toLowerCase();
            //判断ua和微信浏览器的标识头是否匹配
            if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
                    return true;
            } else {
                    return false;
            }
        },
      
      // 客服弹窗
      handleDialog2() {
        this.dialog2 = true
      },
      callUs(type) {
        if(type === 'phone') {
          // 电话
          this.chat()
        }else if(type === 'online') {
          // 在线客服
          this.callMe()
        }
      },


      callMe() {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc3ab9163b32d2aaba';
        // window.location.href = 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn'
      },
      chat(){
            // this.$router.push('/customerService')

            this.$dialog.confirm({
                title: '提示',
                message: '确认拨打电话: 400-606-8160 吗？',
                confirmButtonColor: '#04498d',
            })
            .then(() => {
                // on confirm
                window.location.href = `tel:4006068160`;
            })
            .catch(() => {
                // on cancel
            });
        },
      onBlur() {
        setTimeout(()=> {
          this.btnShow = true;
        }, 50);
      },
      onfocus() {
        this.btnShow = false;
      },
      // 快手号输入限制：仅字母、数字、下划线、减号，最长 20
      onAccountInput(e) {
        const value = (e.target.value || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 20);
        this.accountNumber = value;
        if (e.target.value !== value) {
          e.target.value = value;
        }
      },
      // 切换账号
      loginCheckOut() {
        this.accountNumber = '';
        this.userInfo = '';
        this.isLogin = false;
        this.btnDisabled = true;
        
      },
      affirmAcNumber() {
        if (!/^[a-zA-Z0-9_-]{2,20}$/.test(this.accountNumber)) {
          this.$toast('请输入正确的快手号');
          return;
        }
        this.getKsNumber();
      },
  
      // 快手账号确认（第三方接口）
      getKsNumber2() {
          getAvatarInfoKs(this.accountNumber).then((res) =>{
              const {code, data} = res;
              if(code === 0) {
              const {thumb: headImg, name: nickName} = data;
              if(headImg && nickName) {
                  this.isLogin = true;
                  this.btnDisabled = false;
                  this.setStorage({nickName, headImg});
              }else {
                  this.$toast('无法识别快手号');
              }
              }else {
                  this.$toast('无法识别快手号');
              }
          });
      },

      // 快手号识别
      getKsNumber() {
        // 不识别：直接成功，避免识别接口失效阻断充值
        if (!this.needKsDiscern) {
          this.isLogin = true;
          this.btnDisabled = false;
          this.setStorage({ nickName: '', headImg: '' });
          return;
        }

        this.isLoading = true;
        let settled = false;

        const doneSuccess = ({ nickName, headImg }) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          this.isLoading = false;
          this.isLogin = true;
          this.btnDisabled = false;
          this.setStorage({ nickName, headImg });
        };

        const doneFail = (msg) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          this.isLoading = false;
          this.$toast(msg || '无法识别快手号');
        };

        const timer = setTimeout(() => {
          doneSuccess({ nickName: this.accountNumber, headImg: '' });
        }, 3000);

        getKsAccoutInfo(this.accountNumber).then((res) => {
          const { result, headUrl: headImg, userName: nickName, error_msg } = res;
          if (result === 1) {
            doneSuccess({ nickName, headImg });
          } else {
            doneFail(error_msg);
          }
        }).catch(() => {
          doneFail('无法识别快手号');
        });
      },
  
  
      setStorage({headImg, nickName}) {
        this.userInfo = {
          userId: this.accountNumber,
          headImg: headImg || '',
          nickName: nickName || '',
        };
        localStorage.setItem('ksData', JSON.stringify(this.userInfo));
      },
      
  
      handerList(item, idx) {
        console.log(item);
        
        
        this.currItem = item;
        this.currIdx = idx;
      },
      openPayMode() {
        this.dialog = true;
      },

      toWxAuth(payType) {
        const {orderType, hasPaySys = 'Y'} = this.webInfoObj;
        this.toastLoading = this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
        });


        
        const {money, doubi, id} = this.list[this.currIdx];
        const queryObj = {
            money, 
            doubi, 
            id, 
            orderType,
            type: 'ks',
            payType,
            ...this.userInfo
        }

        const params = {
            ...queryObj,
            productNo: id,
        };
        
        if(this.is_weixn()) {
            var queryStr = qs.stringify(params)
            const u = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2a5f52f9d521f5f3&redirect_uri=${encodeURIComponent('https://mvp.bxsvip.com/#/middleAuth2?'+queryStr)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            const u3 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdf8cd8dee821c0eb&redirect_uri=${encodeURIComponent('https://mvp.bxsvip.com/#/middleAuth3?'+queryStr)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            window.location.href = (orderType == 30 ? u3 : u);
        } else {
            this.$toast('请在微信内浏览器打开');
        }
      },


      

      // 微信支付下单
      async weChatPay() {
        
        const {money, doubi, id} = this.list[this.currIdx];
        const {orderType, hasPaySys = 'Y'} = this.webInfoObj;
        var u = navigator.userAgent; 
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        // 是否可以跳转支付页面
        if(isAndroid && hasPaySys === 'N') {
          this.$router.push('/error')
          return
        }

        /*
        if(money >= 3000 & orderType == 20) {
            this.$toast('商品库存不足，请选择其他面额。')
            return
        }
        */

        
        this.getApPayAuto()
      },
      // 获取是否有支付宝支付权限
      getApPayAuto() {
        // 全部放开支付宝
        this.toastLoading = this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        });

        const {id} = this.list[this.currIdx]
      const {orderType} = this.webInfoObj;
        const params = {
          userId: this.accountNumber,
          productNo: id,
          orderType
        }
        apPayAuto(qs.stringify(params)).then(res => {
          this.toastLoading.clear()
          
          if(res.code === 200) {
            this.isApPayAuth = res.data

            // 如果是支付宝黑名单，增加风险提示弹窗
            if(!this.isApPayAuth) {
              
              this.showRiskDialog()
            } 
            else {  
              // 正常逻辑
              this.payTypeDialog = true; 
            }
          }


        })
      },

      // 显示风险提示弹窗
      showRiskDialog() {
        this.isSelfCharger = true
        this.payTypeDialog2 = true; 
        this.timerCount = 3
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.timerCount--
          if(this.timerCount === 0) {
            clearInterval(this.timer)
          }

        }, 1000)
      },
      // 退出
      getOut() {
        this.payTypeDialog2 = false
        this.isSelfCharger = false
      },


      // 弹窗支付选择
        dialogPay(type) {
            if(!this.accountNumber) {
                this.$toast('请输入充值账号');
                return;
            }
            if(this.blackList.includes(this.accountNumber)) {
                this.$toast('暂无权限');
                return;
            }
            this.toWxAuth(type);
        }
    },
  };
  </script>
  
  <style lang="less" scoped>
  .bottom-tips {
    padding: 8px 10px;
    background-color: #eaf4f9;
    margin-top: 10px;
    border-radius: 4px;
    line-height: 22px;
}
  .complaint {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    margin: 5px auto;
    font-size: 14px;
    img {
        margin-right: 3px;
    }
}
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  
  #Agreement {
    position: relative;
    width: 100vw;
    min-height: 100vh;
    text-align: justify;
    background: #fff;
  }
  #Agreement .floor {
    padding: 15px 15px 15px;
    color: rgba(0, 0, 0, 0.6);
  }
  #Agreement .floor strong {
    font-weight: 700;
  }
  #Agreement .text {
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    line-height: 22px;
    white-space: pre-line;
  }

  .van-dialog-paytype {
    top: 50% !important;
}
.paytype-wrap {
    padding: 20px 25px;
    position: relative;
    .pay-header {
        text-align: right;
        position: absolute;
        right: 10px;
        top: 10px
    }
    .row {
        text-align: center;
        margin-bottom: 10px;
    }
    .row-img img{
        border-radius: 4px !important;
        width: 100px;
    }
    .pay-footer {
        .van-button__icon {
            font-size: 20px;
        }
        .van-button--disabled {
      opacity: 1;
    }
    }
}


.dialog-tips {
  padding: 0;
  font-size: 14px;
  .risk-header {
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #e0f2ff;
    font-size: 16px;
    color: #2878ff;
  }
  .risk-body {
    padding: 20px 20px;
  }
  .risk-error {
    .title {
      font-size: 16px;
      color: #ff2e39;
      padding: 20px 20px 0;
    }
    .error-list {
      padding: 20px 20px;
      p {
        color: #ff2e39;
        margin-bottom: 8px;
        font-size: 14px;
      }
      .van-button {
        border-radius: 999px !important;
        margin: 30px 0 0 0;
      }
    }
  }
  .row,
  .row-img{
    text-align: left;
    display: flex;
    align-items: center;
    img {
      border-radius: 50% 50% !important;
      width: 40px;
    }
  }
  .pay-footer {
    .van-button {
      border-radius: 999px !important;
      font-size: 14px;
      &.van-button--default {
        background-color: #f5f5f5;
        color: #999;
      }
    }
    p {
      text-align: center;
      color: #999;
      margin: 12px 0;
      font-size: 14px;
      span {
        color: #2878ff;
      }
    }
    .risk-row {
      font-size: 14px;
      span {
        color: red;
      }
      .van-checkbox {
        align-items: baseline;
      }
    }
  }
  
}
  </style>
  